<template>
  <div class="content">
    <aside class="aside">
      <strong>{{ $t('app.transfer.notes.title') }}</strong>
      <br />{{ $t('app.transfer.notes.item1') }}
      <br />{{ $t('app.transfer.notes.item2') }}
      <br />{{ $t('app.transfer.notes.item3') }}
      <br />{{ $t('app.transfer.notes.item4') }}
    </aside>
    <el-form :model="ruleForm" ref="ruleForm" label-width="100px" :rules="rules" class="ruleForm">
      <el-form-item :label="$t('app.transfer.agent')" :prop="switchInput?'username':'userId'" label-width="151px" :rules="[{ required: isAgentRequired, message: switchInput?$t('app.transfer.validate.agentRequired'):this.$t('app.transfer.validate.accountRequired'), trigger: 'blur'}]">
        <el-cascader
          v-if="!switchInput"
          @change="handleSelectUser"
          :placeholder="$t('app.transfer.selectAgent')"
          ref="myCascader"
          :options="agentoptions"
          :props="{ value : 'userId' , label : 'name' , checkStrictly: true,emitPath : false }"
          :show-all-levels="false"
          clearable
          style="width: 460px"
          v-model="ruleForm.userId"
          filterable
        ></el-cascader>
        <el-input
          v-if="switchInput"
          v-model="ruleForm.username"
          :placeholder="$t('app.transfer.enterAgentAccount')"
          style="width:460px;font-size:14px"
        ></el-input>
        <el-button style="margin-left:8px" type="primary" v-hasPermi="['card:allocation:switch']" @click="handelSwitchInput">{{switchInput?$t('app.transfer.dropdownSelect'):$t('app.transfer.manualInput')}}</el-button>
      </el-form-item>
      <el-form-item label="方案" prop="serviceProviderId" label-width="151px" v-if="adminShow">
        <el-select v-model="ruleForm.serviceProviderId" clearable placeholder="请选择方案" style="width:460px" @change="handleSelectProvider">

          <el-option
            v-for="item in serviceProviderList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('app.transfer.needRealName')" prop="status" label-width="151px" v-if="adminShow">
        <template>
          <el-switch
            v-model="ruleForm.status"
            active-color="#13ce66"
            inactive-color="#DCDFE6"
            active-value="1"
            inactive-value="0"
          ></el-switch>
        </template>
      </el-form-item>

      <el-form-item :label="$t('app.transfer.showSmsPackage')" prop="simProduct" label-width="151px" v-if="adminShow">
        <template>
          <el-switch
            v-model="ruleForm.simProduct"
            active-color="#13ce66"
            inactive-color="#DCDFE6"
            active-value="1"
            inactive-value="0"
          ></el-switch>
        </template>
      </el-form-item>
      <el-form-item prop="fieldType" label-width="151px" v-if="adminShow">
        <el-radio v-model="ruleForm.fieldType" label="1" >ICCID</el-radio>
        <el-radio v-model="ruleForm.fieldType" label="2" >MSISDN</el-radio>
      </el-form-item>
      <el-form-item :label="ruleForm.fieldType == '1'?'ICCIDS':'MSISDNS'" prop="iccids" label-width="151px">
        <el-input
          v-model="ruleForm.iccids"
          type="textarea"
          :placeholder="$t('app.transfer.iccidsPlaceholder')"
          rows="6"
          @input="changeAllocationIccids"
          style="width:460px;font-size:14px"
        ></el-input>
        <div class="card-num" v-if="allocationIccidsCount>0"><span>总数：</span><span>{{allocationIccidsCount}}</span></div>
      </el-form-item>
      <el-form-item :label="ruleForm.fieldType == '1'?'ICCID号段':'MSISDN号段'" prop="startIccid" label-width="151px">
        <el-input
          v-model="ruleForm.startIccid"
          style="width: 220px;margin-right: 10px;"
          clearable
          :placeholder="$t('app.transfer.includeStartValue')"
          @input="changeAllocationIccidRangeCount"
        ></el-input>
        <span>-</span>
        <el-input
          v-model="ruleForm.endIccid"
          style="width: 220px;margin-left: 10px;"
          clearable
          :placeholder="$t('app.transfer.includeEndValue')"
          @input="changeAllocationIccidRangeCount"
        ></el-input>
        <div class="card-num" v-if="allocationIccidRangeCount>0"><span>总数：</span><span>{{allocationIccidRangeCount}}</span></div>
      </el-form-item>
      <el-form-item v-if="commissionModel == '1'" :label="$t('app.transfer.basePriceScheme')" prop="schemeId" label-width="151px">
          <el-select v-model="ruleForm.schemeId" :placeholder="$t('app.transfer.selectScheme')" @change="handleSelectScheme">
            <el-option  v-for="item in schemeList" :key="item.id" :label="'['+item.id+']'+item.name" :value="item.id"></el-option>
          </el-select>
      </el-form-item>
      <el-form-item v-if="adminShow && commissionModel == '1'"   label="" label-width="151px">
          <el-table :data="schemeDetail.services" row-key="id"
            border
            max-height="300"
            :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
            <el-table-column prop="productName" :label="$t('app.transfer.table.packageName')" align="center"  :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="operationName" :label="$t('app.transfer.table.operator')" align="center"  ></el-table-column>
            <el-table-column prop="ledgerPrice" :label="$t('app.transfer.table.basePrice')" align="center" ></el-table-column>
            <el-table-column prop="salePrice" :label="$t('app.transfer.table.salePrice')" align="center" ></el-table-column>
          </el-table>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="medium" @click="submitForm('ruleForm')" >{{ $t('app.common.submit') }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { agentTreeList , agentInfo , baseSchemeAll ,schemeDetail } from "@/api/api.js"; //获取代理商的数据
import { selectCount , assignCard , serviceProviderListAll} from "@/api/api.js"; //卡分配的提交
export default {
  name:"transfer",
  data() {
    return {
      ruleForm: {
        fieldType:"1",
        userId:undefined,
        username:undefined,
        iccids:'',
        startIccid:undefined,
        endIccid:undefined,
        serviceProviderId:undefined,
        status:'0',
        simProduct:'0',
        schemeId:undefined
      },
      allocationIccidsCount:0,
      allocationIccidRangeCount:0,

      isAgentRequired: true,
      agentoptions: [],
      submitLoading:false,
      commissionModel:"0",
      schemeList:[],
      schemeDetail:{},
      rules: {
        userId: [
          { required: true, message: this.$t('app.transfer.validate.agentRequired'), trigger: "blur" },
        ],
        username: [
          { required: true, message: this.$t('app.transfer.validate.accountRequired'), trigger: "blur" },
        ],
      },
      switchInput:false,
      serviceProviderList:[]
    };
  },
  watch:{
    $route: {
      handler: function(to, from){
        if(to.name == 'transfer'){
          let arrIccids = this.$route.params.iccids || []
          if(arrIccids.length>0){
            this.$set(this.ruleForm,"iccids",this.$route.params.iccids);
            this.changeAllocationIccids()
          }
          this.handleAgentTreeList();
        }
      },
      deep: true,
      immediate:true
    }
  },
  computed: {
    adminShow(){
        return this.$store.getters.user.userType =='1'
    },
  },
  methods: {
    initServiceProviderList(){
      serviceProviderListAll().then(res=>{
        this.serviceProviderList = res.data.data
      })
    },
    submitForm() {
      let { iccids } = this.ruleForm;
      let params = {
        ...this.ruleForm,
        iccids:iccids ? iccids.split("\n") : []
      };
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          assignCard(params).then(res => {
              this.$notify.info({
                title: this.$t('app.common.tip'),
                message: this.$t('app.transfer.submit.success'),
                duration: 1000,
                offset:30
              });
              
              setTimeout(()=>{
                // 保留原对象引用，逐个重置属性以保持 Vue 2 响应式
                this.ruleForm.fieldType = '1'
                this.ruleForm.userId = undefined
                this.ruleForm.username = undefined
                this.ruleForm.iccids = ''
                this.ruleForm.startIccid = undefined
                this.ruleForm.endIccid = undefined
                // 仅在下拉选择模式下才重置 cascader，避免 switchInput 为 true 时 myCascader 不存在导致报错
                if (this.$refs.myCascader) {
                  this.$refs.myCascader.$refs.panel.clearCheckedNodes();
                  this.$refs.myCascader.$refs.panel.activePath = [];
                }
                this.allocationIccidsCount = 0
                this.allocationIccidRangeCount = 0
                this.$router.push({ path: `/taskCenter/missionList`});
              },1000)
          })
        }
      });
    },
    handleAgentTreeList(){
      agentTreeList().then(res => {
        this.agentoptions = res.data.data;
      });
    },
    handleSelectUser(userId){
      if(!userId){
          this.commissionModel = '0'
          this.schemeDetail = {}
          return 
      }
      if(this.adminShow){
        agentInfo({userId}).then(res=>{
          let data = res.data.data
          this.commissionModel = data.commissionModel
          if(data.commissionModel == '1'){
              this.selectBaseScheme()
          }
        })
      }
    },
    handleSelectProvider(serviceProviderId){
      if(!serviceProviderId){
        this.isAgentRequired = true;
        return 
      }
      this.$refs.ruleForm.clearValidate()
      this.isAgentRequired = false;
    },
    //查询自建方案
    selectBaseScheme(){
      baseSchemeAll().then(res=>{
        this.schemeList = res.data.data
      })
    },
    //选中方案
    handleSelectScheme(schemeId){
      schemeDetail({schemeId}).then(res=>{
        this.schemeDetail = res.data.data
      })
    },
    handelSwitchInput(){
      this.switchInput = !this.switchInput
      if(this.switchInput){
        this.ruleForm.userId = undefined
      }else{
        this.ruleForm.username = undefined
      }
    },
    changeAllocationIccids(){
      let arrIccids = this.ruleForm.iccids ? this.ruleForm.iccids.split("\n") : []
      this.allocationIccidsCount = arrIccids.filter(item=>!!item).length
    },
    changeAllocationIccidRangeCount(){
      this.allocationIccidRangeCount = 0
      let fieldType = this.ruleForm.fieldType
      if(!!this.ruleForm.startIccid && !!this.ruleForm.endIccid){
            if(this.ruleForm.fieldType === '1'  && this.ruleForm.startIccid.length>18 && this.ruleForm.endIccid.length>18){
              let startIccid = this.ruleForm.startIccid
              let endIccid =  this.ruleForm.endIccid
              selectCount({fieldType,startIccid,endIccid}).then(res=>{
                this.allocationIccidRangeCount = res.data.data
              })
            }
            if(this.ruleForm.fieldType === '2'  && this.ruleForm.startIccid.length>12 && this.ruleForm.endIccid.length>12){
              let startIccid = this.ruleForm.startIccid
              let endIccid =  this.ruleForm.endIccid
              selectCount({fieldType,startIccid,endIccid}).then(res=>{
                this.allocationIccidRangeCount = res.data.data
              })
            }
      }

    }
  },

  created() {
    this.handleAgentTreeList();
    if(this.adminShow){
      this.initServiceProviderList()
      this.allocationIccidRangeCount = 0
      let arrIccids = this.ruleForm.iccids ? this.ruleForm.iccids.split("\n") : []
      this.allocationIccidsCount = arrIccids.filter(item=>!!item).length
      this.changeAllocationIccidRangeCount()
    }
  },
};
</script>
<style scoped lang="less">
  .card-num{
    height: 20px;
    line-height: 20px;
    span:nth-of-type(2){
      color:red
    }
  }
  .aside {
    background: #eef1f6;
    padding: 8px 24px;
    margin-bottom: 20px;
    border-radius: 2px;
    display: block;
    line-height: 32px;
    font-size: 16px;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen,
      Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
    color: #2c3e50;
    -webkit-font-smoothing: antialiased;
    margin-left: 20px;
    width: 50%;
  }
  .aspan{
    display: inline-block;
    width: 18px;
  }
</style>
